import { z } from 'my-zod'
import { IsProductTypeOnRoad, productLineOptions, productLines } from '../../internal'

export const vehicleUseHistoryBaseFragment = z.object({
  images: z.array(z.string()),
  productLine: z.enum(productLineOptions).nullish(),
  fuelLevel: z.string().optional(),
  engineHours: z.number().optional(),
  mileage: z.number().optional(),
  treadDepth32ndInches: z.number().optional(),
  notes: z.string().nullable()
})

export const vehicleUseHistorySuperRefine = <T extends z.infer<typeof vehicleUseHistoryBaseFragment>>(
  values: T,
  ctx: z.RefinementCtx
) => {
  if (!values.images.length) {
    ctx.addIssue({
      message: 'Required',
      code: z.ZodIssueCode.custom,
      path: ['images']
    })
  }
  if (!values.fuelLevel) {
    ctx.addIssue({
      message: 'Required',
      code: z.ZodIssueCode.custom,
      path: ['fuelLevel']
    })
  }
  if (IsProductTypeOnRoad(values.productLine) && !values.treadDepth32ndInches) {
    ctx.addIssue({
      message: 'Required',
      code: z.ZodIssueCode.custom,
      path: ['treadDepth32ndInches']
    })
  } else if (!IsProductTypeOnRoad(values.productLine) && !values.engineHours) {
    ctx.addIssue({
      message: 'Required',
      code: z.ZodIssueCode.custom,
      path: ['engineHours']
    })
  }
  if (productLines.PON !== values.productLine && !values.mileage) {
    ctx.addIssue({
      message: 'Required',
      code: z.ZodIssueCode.custom,
      path: ['mileage']
    })
  }
}
